import React, { Component, useRef, useState } from "react";
import { GOOGLE_API_KEY } from "../../../../../../../config/Keys";
import GeoLocation from "../../../../../superAdminAllComponent/SuperAdminAddVendorComponent/MapSetup/GeoLoaction";
import Alert from "react-s-alert";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import Autocomplete from "react-google-autocomplete";
import Switch from "react-switch";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../../../store/actions/errorActions";
import {
  getArea,
  getCity,
  getState,
  GetAddressFromLatLng,
  getPinCode,
} from "../../../../../superAdminAllComponent/SuperAdminAddVendorComponent/MapSetup/MapUtils";
import { Image, FormControl } from "react-bootstrap";

import CurbSideMapWrapper from "./CurbSideMapWrapper";
import { superadmin_create_and_update_restaurant } from "../../../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import isEmpty from "../../../../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import { NewInputText } from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";

import store from "../../../../../../../store/store";
import {
  SET_CURBSIDE_LOCATION,
  SET_CURBSIDE_LOCATION_ARR,
  SET_FASTFOOD_CURBSIDE_LOCATION_ARR,
  SET_MULTISERVICE_CURBSIDE_LOCATION_ARR,
} from "../../../../../../../store/types";
import { AddButtonIconComponent } from "../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { IconButton } from "@material-ui/core";

const google_API_Key = GOOGLE_API_KEY;

export class CurbSideMapSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vendor_id: "",
      user: null,
      actionButton: false,
      loader: false,
      id: "",
      selectedTab: 1,
      google_place_id: "",
      restaurant_address: "",
      city: "",
      area: "",
      state: "",
      pinCode: "",
      location: {
        type: "Point",
        coordinates: ["", ""],
      },
      hasSetMapProps: false,
      errors: {},
      zoom: 15,

      name: "",
      activePickupPointStatus: false,
      dropDownBox: false,
      allPickupPoints: [],
      editKey: "",
      editButton: false,
    };
  }

  componentDidMount() {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    let adminVendorId = this.props?.editDataAction
      ? this.props?.editData?.vendor_id
      : JSON.parse(localStorage.getItem("vendorId"));
    const formData = {
      vendor_id: adminVendorId,
    };
    // if (adminVendorId !== null || adminVendorId !== undefined) {
    //   this.props.superadmin_create_and_update_restaurant(formData);
    //   this.setState({
    //     vendor_id: formData.vendor_id,
    //   });
    // }
    if (
      onboarding?._id &&
      !isEmpty(onboarding?.location) &&
      !isEmpty(onboarding?.location?.coordinates)
    ) {
      this.onGetGeoCodetoState(
        onboarding?.location?.coordinates[1],
        onboarding?.location?.coordinates[0]
      );
    } else if (
      this.props?.location?.state !== null &&
      this.props?.location?.state !== undefined
    ) {
      this.onGetGeoCodetoState(
        this?.props?.location?.state?.location?.lat,
        this?.props?.location?.state?.location?.lng
      );
    } else {
      this.onGetGeoCodetoState(18.5132515, 73.937661);
    }
    if (
      this.props?.location?.state !== null &&
      this.props?.location?.state !== undefined
    ) {
      if (
        !isEmpty(this.props?.location?.state?.actionButton) !==
        this.state.actionButton
      ) {
        this.setState({
          actionButton: this.props?.location?.state?.actionButton,
        });
      }
    }
    if (this.props?.location?.pathname === "/multi-service/ordering/curbside") {
      this.setState({
        allPickupPoints:
          this.props?.subscriptionData?.multi_service_business_status?.ordering
            ?.cubside_delivery?.pickup_location,
      });
    } else if (
      this.props?.location?.pathname === "/fastfood/ordering/curbside"
    ) {
      this.setState({
        allPickupPoints:
          this.props?.subscriptionData?.fast_food_dining_status?.ordering
            ?.cubside_delivery?.pickup_location,
      });
    } else {
      this.setState({
        allPickupPoints:
          this.props?.subscriptionData?.casual_dining_status?.ordering
            ?.cubside_delivery?.pickup_location,
      });
    }
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (
  //     (!isEmpty(this.state.location.latitude) &&
  //       this.state.google_place_id === "") ||
  //     prevState.location.latitude !== this.state.location.latitude
  //   ) {
  //     this.onGetGeoCodetoState(
  //       this.state.location.latitude,
  //       this.state.location.longitude
  //     );
  //   }
  // }

  static getDerivedStateFromProps(nextProps, nextState) {
    let onboarding = nextProps?.editDataAction
      ? nextProps?.editData
      : nextProps?.onboardingData;
    if (
      onboarding?._id &&
      !isEmpty(onboarding?.location) &&
      !isEmpty(onboarding?.location?.coordinates)
    ) {
      if (
        !isEmpty(onboarding?.location?.coordinates[1]) &&
        !isEmpty(onboarding?.location?.coordinates[0]) &&
        !nextState?.hasSetMapProps
      ) {
        return {
          location: {
            coordinates: [
              onboarding?.location?.coordinates[1],
              onboarding?.location?.coordinates[0],
            ],
          },
          hasSetMapProps: true,
        };
      }
    }
    return null;
  }

  onGetGeoCodetoState = async (lat, lng) => {
    let response = await GetAddressFromLatLng(lat, lng);
    let location = {
      type: "Point",
      coordinates: [lat, lng],
    };
    this.setState({
      google_place_id: response.place_id,
      restaurant_address: response.address,
      area: response.area,
      city: response.city,
      state: response.state,
      pinCode: response.pinCode,
      location: location,
    });
  };

  onAutoDetectHandler = async (e) => {
    let location = await GeoLocation(window.navigator);
    this.onGetGeoCodetoState(location.lat, location.lng);
  };

  onZoomChanged = (map) => {
    if (map?.current) this.setState({ zoom: map.current.getZoom() });
  };

  // *********************** MAP METHODS//
  onMarkerDragEnd = async (event) => {
    this.onGetGeoCodetoState(event.latLng.lat(), event.latLng.lng());
    this.setState({
      actionButton: true,
    });
  };

  onPlaceSelected = (place) => {
    let location = {
      type: "Point",
      coordinates: [
        place.geometry.location.lat(),
        place.geometry.location.lng(),
      ],
    };
    this.setState({
      google_place_id: place.place_id ? place.place_id : "",
      restaurant_address: place.formatted_address
        ? place.formatted_address
        : "",
      area: getArea(place.address_components),
      city: getCity(place.address_components),
      state: getState(place.address_components),
      pinCode: getPinCode(place.address_components),
      location: location,
      actionButton: true,
    });
  };

  onInfoWindowClose = (event) => {};

  //   shouldComponentUpdate(nextProps, nextState) {
  //     if (
  //       this.state.location.coordinates[0] !==
  //         nextState.location.coordinates[0] ||
  //       this.state.location.coordinates[1] !==
  //         nextState.location.coordinates[1] ||
  //       this.state.google_place_id !== nextState.google_place_id ||
  //       this.state.restaurant_address !== nextState.restaurant_address ||
  //       this.state.city !== nextState.city ||
  //       this.state.area !== nextState.area ||
  //       this.state.state !== nextState.state ||
  //       this.state.errors !== nextState.errors ||
  //       this.state.loader !== nextState.loader
  //     ) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   }

  /********************************************
   * @DESC CURB SIDE CHANGES ALL ACTION
   ********************************************/
  onChange = (event) => {
    this.setState({ name: event.target.value });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `*Pickup point is required`;
    } else {
      delete errors[e.target.name];
    }
    this.setState({
      errors: errors,
      error: Object.keys(errors).length > 0 ? true : false,
    });
  };

  onActivePickupPointChange = () => {
    this.setState({
      activePickupPointStatus: !this.state.activePickupPointStatus,
    });
  };
  dropDownBoxClick = () => {
    this.setState({
      dropDownBox: !this.state.dropDownBox,
    });
  };

  onEmailAddHandler = (e) => {
    const {
      name,
      google_place_id,
      restaurant_address,
      location,
      activePickupPointStatus,
      allPickupPoints,
    } = this.state;
    if (name === "") {
      const { errors } = this.state;
      errors.name = "Pickup Point is required";
      this.setState({
        errors: errors,
      });
    } else {
      if (allPickupPoints.length === 0) {
        let contactData = {
          id: 1,
          name: this.state.name,
          address: restaurant_address,
          latitude: location.coordinates[0],
          longitude: location.coordinates[1],
          place_id: google_place_id,
          pickup_point_status: activePickupPointStatus,
        };
        allPickupPoints.push(contactData);
        this.setState({
          allPickupPoints: allPickupPoints,
          name: "",
          activePickupPointStatus: false,
        });
        store.dispatch({
          type:
            this.props.actionBy === "CasualDiningCurbSide"
              ? SET_CURBSIDE_LOCATION_ARR
              : this.props.actionBy === "FastFoodCurbSide"
              ? SET_FASTFOOD_CURBSIDE_LOCATION_ARR
              : SET_MULTISERVICE_CURBSIDE_LOCATION_ARR,
          payload: allPickupPoints,
        });
      } else {
        let id = allPickupPoints[allPickupPoints.length - 1].id;
        let contactData = {
          id: id + 1,
          name: this.state.name,
          address: restaurant_address,
          latitude: location.coordinates[0],
          longitude: location.coordinates[1],
          place_id: google_place_id,
          pickup_point_status: activePickupPointStatus,
        };
        allPickupPoints.push(contactData);
        this.setState({
          allPickupPoints: allPickupPoints,
          name: "",
          activePickupPointStatus: false,
        });
        store.dispatch({
          type:
            this.props.actionBy === "CasualDiningCurbSide"
              ? SET_CURBSIDE_LOCATION_ARR
              : this.props.actionBy === "FastFoodCurbSide"
              ? SET_FASTFOOD_CURBSIDE_LOCATION_ARR
              : SET_MULTISERVICE_CURBSIDE_LOCATION_ARR,
          payload: allPickupPoints,
        });
      }
    }
  };

  onClickEditCurbSideLocation = (id) => (e) => {
    this.setState({
      editButton: true,
    });
    const {
      name,
      google_place_id,
      restaurant_address,
      location,
      activePickupPointStatus,
    } = this.state;
    let allPickupPoints = this.state.allPickupPoints;
    let phoneObj = allPickupPoints.find((phone) => phone.id === id);
    let indexOf = allPickupPoints.indexOf(phoneObj);
    let contactData = {
      id: allPickupPoints.length + 1,
      name: name,
      address: restaurant_address,
      latitude: location.coordinates[0],
      longitude: location.coordinates[1],
      place_id: google_place_id,
      pickup_point_status: activePickupPointStatus,
    };
    let to_be_set = allPickupPoints[indexOf];
    allPickupPoints.splice(indexOf, 1);
    allPickupPoints.push(contactData);
    this.setState({
      editKey: id,
      // name: allPickupPoints[indexOf].name,
      // restaurant_address: allPickupPoints[indexOf].address,
      // latitude: location.coordinates[0],
      // longitude: location.coordinates[1],
      // google_place_id: allPickupPoints[indexOf].place_id,
      activePickupPointStatus: allPickupPoints[indexOf].pickup_point_status,
      allPickupPoints: allPickupPoints,
      ...to_be_set,
    });
  };

  saveEditButtonHandler = (e) => {
    e.preventDefault();
    const {
      name,
      google_place_id,
      restaurant_address,
      location,
      activePickupPointStatus,
    } = this.state;
    let contacts_array = this.state.allPickupPoints;
    let contactData = {
      id: contacts_array.length + 1,
      name: name,
      address: restaurant_address,
      latitude: location.coordinates[0],
      longitude: location.coordinates[1],
      place_id: google_place_id,
      pickup_point_status: activePickupPointStatus,
    };

    let to_be_set = contacts_array[contacts_array.length - 1];
    let to_be_displayed = contacts_array;
    to_be_displayed.splice(contacts_array.length - 1, 1);
    to_be_displayed.push(contactData);

    this.setState({
      allPickupPoints: contacts_array,
      editKey: "",
      editButton: false,
      activePickupPointStatus: false,
      ...to_be_set,
    });
    store.dispatch({
      type:
        this.props.actionBy === "CasualDiningCurbSide"
          ? SET_CURBSIDE_LOCATION_ARR
          : this.props.actionBy === "FastFoodCurbSide"
          ? SET_FASTFOOD_CURBSIDE_LOCATION_ARR
          : SET_MULTISERVICE_CURBSIDE_LOCATION_ARR,
      payload: contacts_array,
    });
  };

  onClickDeleteLocation = (id) => (e) => {
    e.preventDefault();
    let allPickupPoints = this.state.allPickupPoints;
    let emailObj = allPickupPoints.find((email) => email.id === id);
    if (emailObj === 0 || emailObj) {
      allPickupPoints.splice(allPickupPoints.indexOf(emailObj), 1);
      this.setState({ allPickupPoints: allPickupPoints });
    }
    store.dispatch({
      type:
        this.props.actionBy === "CasualDiningCurbSide"
          ? SET_CURBSIDE_LOCATION_ARR
          : this.props.actionBy === "FastFoodCurbSide"
          ? SET_FASTFOOD_CURBSIDE_LOCATION_ARR
          : SET_MULTISERVICE_CURBSIDE_LOCATION_ARR,
      payload: allPickupPoints,
    });
  };

  onClickActiveToggleChange = (index) => (e) => {
    let { allPickupPoints } = this.state;
    allPickupPoints[index].pickup_point_status =
      !allPickupPoints[index].pickup_point_status;
    this.setState({
      allPickupPoints: allPickupPoints,
      actionButton: true,
    });
    store.dispatch({
      type:
        this.props.actionBy === "CasualDiningCurbSide"
          ? SET_CURBSIDE_LOCATION_ARR
          : this.props.actionBy === "FastFoodCurbSide"
          ? SET_FASTFOOD_CURBSIDE_LOCATION_ARR
          : SET_MULTISERVICE_CURBSIDE_LOCATION_ARR,
      payload: allPickupPoints,
    });
  };

  /********************************************
   * @DESC CURB SIDE CHANGES ALL ACTION END
   ********************************************/

  localProps = {
    onZoomChanged: this.onZoomChanged,
    onAutoDetectHandler: this.onAutoDetectHandler,
    // onSubmitHandler: this.onSubmitHandler,
    onMarkerDragEnd: this.onMarkerDragEnd,
    onPlaceSelected: this.onPlaceSelected,
    onInfoWindowClose: this.onInfoWindowClose,
  };

  render() {
    console.log(this.state);
    // let {latitude, longitude} = this.state.location;
    let latitude = this.state.location.coordinates[0];
    let longitude = this.state.location.coordinates[1];
    latitude = parseFloat(latitude);
    longitude = parseFloat(longitude);
    this.localProps.state = this.state;

    const formData = {
      lat: this.state?.location?.coordinates[0],
      lng: this.state?.location?.coordinates[1],
      placeId: this.state?.google_place_id,
      address: this.state?.restaurant_address,
    };
    store.dispatch({ type: SET_CURBSIDE_LOCATION, payload: formData });

    return (
      <>
        <div>
          <h4 className="f12-500 mt-3 mb-4">Set Curbside pickup location</h4>
          <div className="col-9 p-0">
            <NewInputText
              extraClass="mt-4 mb-0"
              name="name"
              inputType="text"
              onChange={this.onChange}
              onFocusOut={this.onFocusOut}
              value={this.state.name}
              // maxLength={35}
              labelText="Pickup Point Name"
              errorText={
                this.state.errors.name === "*Pickup point is required"
                  ? "*Pickup point is required"
                  : null
              }
              errorTrue={
                this.state.errors.name === "*Pickup point is required"
                  ? true
                  : false
              }
              controlClass={
                this.state.errors.name === "*Pickup point is required"
                  ? "outlined-error-helper-text"
                  : "outlined-helperText "
              }
            />
          </div>
        </div>
        <CurbSideMapWrapper localProps={this.localProps} state={this.state}>
          {latitude !== "" &&
          latitude !== undefined &&
          longitude !== "" &&
          longitude !== undefined ? (
            <React.Fragment>
              <DisplayMap localProps={this.localProps} zoom={this.state.zoom} />
              <DisplayPlaceId localProps={this.localProps} />
            </React.Fragment>
          ) : null}
        </CurbSideMapWrapper>
        <div className="row">
          <div className="col-6">
            <span className="text-nowrap">Pickup point Status</span>
          </div>
          <div className="col-6">
            <div className="offers-events-screen-yes-no-toggle">
              <h3
                className={
                  this.state.activePickupPointStatus === false
                    ? "offers-events-yes-no-active"
                    : "offers-events-yes-no-notactive"
                }
              >
                Inactive
              </h3>
              <Switch
                checked={this.state.activePickupPointStatus}
                onChange={this.onActivePickupPointChange}
                offColor="#EEEEEE"
                onColor="#EEEEEE"
                offHandleColor="#212121"
                onHandleColor="#59F832"
                handleDiameter={16}
                uncheckedIcon={false}
                checkedIcon={false}
                height={10}
                width={27}
                boxShadow="-2px 0px 5px #0000003B"
                activeBoxShadow="-2px 0px 5px #0000003B"
                className={`ml-3 mr-3`}
                id="material-switch"
              />
              <h3
                className={
                  this.state.activePickupPointStatus === true
                    ? "offers-events-yes-no-active"
                    : "offers-events-yes-no-notactive"
                }
              >
                Active
              </h3>
            </div>
          </div>
        </div>
        <div className="mt-4 mb-4">
          <AddButtonIconComponent
            buttonText="Save and Add Another Location"
            onClick={
              this.state.editButton
                ? this.saveEditButtonHandler
                : this.onEmailAddHandler
            }
            fontIcon="fa fa-plus"
            colorCss="blue"
          />
        </div>
        {/* <CurbSideMapWrapper /> */}
        <div className="row">
          <div className="col-12 map-button-box-main">
            <button
              className="btn f12-500 p-0"
              style={{ color: "#EE3A23" }}
              onClick={this.dropDownBoxClick}
              type="button"
            >
              {this.state.dropDownBox
                ? "Hide Added Location"
                : "Show Added Location"}
              {this.state.dropDownBox ? (
                <i className="fa fa-chevron-up pl-2" aria-hidden="true"></i>
              ) : (
                <i className="fa fa-chevron-down pl-2" aria-hidden="true"></i>
              )}
            </button>
          </div>
        </div>
        <div className="col-12">
          {this.state.dropDownBox ? (
            <div className="row mt-3">
              <div className="col-1 f12-700 pl-0">No.</div>
              <div className="col-2 f12-700 p-0">Pickup Point Name</div>
              <div className="col-4 text-center f12-700">Pickup Location</div>
              <div className="col-3 text-center f12-700">
                Pickup point Status
              </div>
              <div className="col-2 text-center f12-700 pr-0">Actions</div>
            </div>
          ) : null}
        </div>
        <div className="col-12">
          {this.state.dropDownBox
            ? this.state.allPickupPoints &&
              this.state.allPickupPoints.map((data, index) => {
                const indexCount = index;
                return (
                  <React.Fragment key={index}>
                    <div className="row mt-3 align-items-center">
                      {this.state.editKey === "" ? (
                        <div className="col-1 f12-400 pl-0">{++index}</div>
                      ) : (
                        ""
                      )}
                      {this.state.editKey === "" ? (
                        <div className="col-2 f12-400 p-0">{data.name}</div>
                      ) : (
                        ""
                      )}
                      {this.state.editKey === "" ? (
                        <div className="col-4 text-center f12-400">
                          {data.address}
                        </div>
                      ) : (
                        ""
                      )}
                      {this.state.editKey === "" ? (
                        <div className="col-3 text-center f12-400">
                          <div className="offers-events-screen-yes-no-toggle">
                            {/* <h3
                              className={
                                data.pickup_point_status === false
                                  ? "offers-events-yes-no-active"
                                  : "offers-events-yes-no-notactive"
                              }
                            >
                              Inactive
                            </h3> */}
                            <Switch
                              checked={data.pickup_point_status}
                              onChange={this.onClickActiveToggleChange(
                                indexCount
                              )}
                              offColor="#EEEEEE"
                              onColor="#EEEEEE"
                              offHandleColor="#212121"
                              onHandleColor="#59F832"
                              handleDiameter={16}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              height={10}
                              width={27}
                              boxShadow="-2px 0px 5px #0000003B"
                              activeBoxShadow="-2px 0px 5px #0000003B"
                              className={`ml-3 mr-3`}
                              id="material-switch"
                            />
                            {/* <h3
                              className={
                                data.pickup_point_status === true
                                  ? "offers-events-yes-no-active"
                                  : "offers-events-yes-no-notactive"
                              }
                            >
                              Active
                            </h3> */}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {this.state.editKey === "" ? (
                        <div className="col-2 pr-0 text-center d-flex align-items-center justify-content-end">
                          <IconButton
                            className="mr-2 p-0"
                            onClick={this.onClickEditCurbSideLocation(data.id)}
                          >
                            <Image
                              src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
                              alt="add"
                              title="add"
                              className="w-20px"
                            />
                          </IconButton>
                          <IconButton
                            className="p-0"
                            onClick={this.onClickDeleteLocation(data.id)}
                          >
                            <Image
                              src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                              alt="add"
                              title="add"
                              className="w-20px"
                            />
                          </IconButton>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </React.Fragment>
                );
              })
            : null}
        </div>
      </>
    );
  }
}

CurbSideMapSetup.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  storage: state.storage,
  // onboarding: state?.onboarding?.restaurantDetails,
  onboardingData: state.superAdminOnboarding.restaurantDetails,
  editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
  editDataAction:
    state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,
  subscriptionData:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_create_and_update_restaurant,
})(withRouter(CurbSideMapSetup));

const DisplayMap = (props) => {
  const localProps = props.localProps;
  const { state } = props.localProps;
  const mapHeight = "65vh";
  const zoom = props.zoom;
  const mapRadius = 20000;
  const [mapvars, setMapVar] = React.useState(null);
  const mapRef = useRef(null);
  const [mapState, setMapState] = useState(null);
  function handleLoad(map) {
    mapRef.current = map;
  }

  const handleZoomChanged = () => {
    localProps.onZoomChanged(mapRef);
  };

  const AsyncMap = withScriptjs(
    withGoogleMap((props) => (
      <GoogleMap
        ref={mapRef}
        onLoad={handleLoad}
        google={props.google}
        defaultZoom={zoom}
        onZoomChanged={handleZoomChanged}
        defaultCenter={{
          lat: parseFloat(state.location.coordinates[0]),
          lng: parseFloat(state.location.coordinates[1]),
        }}
        // radius={mapRadius}
      >
        {/* For Auto complete Search Box */}
        <div style={{ position: "absolute", top: "0", width: "100%" }}>
          <Autocomplete
            style={{
              borderRadius: "5px",
              border: "1px solid #9E9E9E",
              width: "100%",
              height: "60px",
              paddingLeft: "10px",
              margin: "-6px 0",
            }}
            onPlaceSelected={localProps.onPlaceSelected}
            types={[]}
            defaultValue={state.restaurant_address}
          />
        </div>
        <Marker
          // google={props.google}
          name={"Dolores park"}
          draggable={true}
          onDragEnd={localProps.onMarkerDragEnd}
          position={{
            lat: parseFloat(state.location.coordinates[0]),
            lng: parseFloat(state.location.coordinates[1]),
          }}
          icon={{
            url: require("../../../../../../../assets/images/UserManagement/map-pin.svg"),
          }}
        >
          <InfoWindow
            onClose={localProps.onInfoWindowClose}
            position={{
              lat: parseFloat(state.location.coordinates[0]),
              lng: parseFloat(state.location.coordinates[1]),
            }}
          >
            <div>
              <div className="f14-400" style={{ color: "#000" }}>
                {state.restaurant_address}
              </div>
              <div className="f14-400 text-break" style={{ color: "#000" }}>
                <span className="text-nowrap">PlaceId: </span>
                <span className="text-break" style={{ color: "#707070" }}>
                  {state.google_place_id}
                </span>
              </div>
            </div>
          </InfoWindow>
        </Marker>
        {/* <Marker /> */}
      </GoogleMap>
    ))
  );
  let map;
  if (
    state.location.coordinates[0] !== undefined &&
    state.location.coordinates[1] !== undefined
  ) {
    map = (
      <div>
        <AsyncMap
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${google_API_Key}&libraries=places`}
          loadingElement={
            <div style={{ height: `100%`, position: "absolute" }} />
          }
          containerElement={
            <div
              style={{
                height: mapHeight,
                position: "relative",
                paddingTop: "55px",
                marginBottom: "30px",
              }}
            />
          }
          mapElement={<div style={{ height: `100%` }} />}
        />
      </div>
    );
  } else {
    map = <div style={{ height: mapHeight }} />;
  }
  return map;
};

const DisplayPlaceId = (props) => {
  const localProps = props.localProps;
  const { state } = props.localProps;
  return (
    <React.Fragment>
      <div className="row ">
        <div className="col-12 location-detections-popup-main h-auto">
          <div className="location-detections-popup-bodyBox">
            <h5 className="col-12 p-0 d-flex location-detections-popup-headingfive">
              <span className="text-nowrap">Place ID: </span>
              <p className="text-break location-detections-popup-paragraphfive">
                {state.google_place_id}
              </p>
            </h5>
            <div className="row mt-4">
              <div className="col-6">
                <NewInputText
                  inputType="number"
                  value={parseFloat(state.location.coordinates[0]).toFixed(5)}
                  labelText="Lattitude"
                  disabled={true}
                />
              </div>
              <div className="col-6">
                <NewInputText
                  inputType="number"
                  value={parseFloat(state.location.coordinates[1]).toFixed(5)}
                  labelText="Longitude"
                  disabled={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
